import React from 'react';
import moment from "moment";
import Link from "../base/Link";
import API from "../base/API";
import Auth from "../auth/Auth";
import Storage from "../base/Storage";
import SorTable from "../base/SorTable";
import DeleteButton from "../base/DeleteButton";
import { translate } from '../base/Translation';

export default class BrandList extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_brands: "/brand/fetch/all?limit_from=:from&limit_max=:to",
			delete_brand: "/brand/delete/:brand"
		});

		this.state = {
			limit_from: 0,
			limit_to: 99999,
			brands: [],
			tableData: [],
			tableColumns: [
				{ name: "name", display: translate("Názov"), sort: true, width: 78 },
				{ name: "date_created", display: translate("Vytvorené"), sort: true, width: 9 },
				{ name: "date_updated", display: translate("Upravené"), sort: true, width: 9 },
				{ name: "options", display: " ", width: 4 }
			]
		};
	}

	convertDataForTable(data) {
		return data.map(function (brand) {
			let data = {};
			data.id = brand.id;
			data.name = <Link to={"/brands/edit/" + brand.id}>{brand.name}</Link>;
			data.date_created = moment(brand.created.date).format("D.M.Y");
			data.date_updated = moment(brand.updated.date).format("D.M.Y");
			data.options = (
				<div style={{ textAlign: "right" }}>
					<DeleteButton onClick={this.deleteBrand.bind({ brand: brand.id, currentComponent: this })} permission="BrandNew" />
				</div>
			);
			return data;
		}.bind(this));
	}

	fetchData() {
		this.api.request({
			cache: true,
			route: "get_brands",
			params: { from: this.state.limit_from, to: this.state.limit_to },
			success: (response) => {
				let tableData = this.convertDataForTable(response);
				this.setState({ brands: response, tableData });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	deleteBrand(evt) {
		this.currentComponent.api.request({
			route: "delete_brand",
			params: { brand: this.brand },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});
	}

	buildTableLoading() {
		return (
			<tr>
				<td colSpan="5">{translate("Načítavam...")}</td>
			</tr>
		)
	}

	render() {
		return (
			<SorTable columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="name" title={translate("Značky")} right={() => {
				if (Storage.get("allowed_components").indexOf("BrandNew") === -1) {
					return "";
				}
				return (
					<Link to="/brands/add/new" permission="BrandNew" className="btn btn-success btn-sm pull-right"><i className="fa fa-plus" /> {translate("Pridať")}</Link>
				)
			}} />
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/brand/BrandList.js